<template>
  <transition name="modal-fade">
    <div class="modal-overlay" v-if="showModalCreate" @click.self="closeModal">
      <div class="modal-container">
        <!-- Botão Fechar -->
        <button class="modal-close" @click="closeModal" aria-label="Fechar modal">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>

        <!-- Header do Modal -->
        <div class="modal-header">
          <div class="modal-icon">
            <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="24" cy="24" r="24" fill="#E1E9F7"/>
              <path d="M24 16v16M16 24h16" stroke="#00235C" stroke-width="3" stroke-linecap="round"/>
            </svg>
          </div>
          <h2 class="modal-title">Abrir Novo Chamado</h2>
          <p class="modal-subtitle">Preencha os campos abaixo para criar um novo chamado de suporte</p>
        </div>

        <!-- Formulário -->
        <form class="modal-form" @submit.prevent="salvarRepresentante">
          <!-- Campo Título -->
          <div class="form-group">
            <label class="form-label" for="titulo">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2 4h12M2 8h12M2 12h8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
              </svg>
              Título do Chamado *
            </label>
            <input
              id="titulo"
              type="text"
              class="form-input"
              placeholder="Ex: Problema com acesso ao sistema"
              v-model="chamado.titulo"
              autocomplete="off"
              :class="{ 'input-error': erroTitulo }"
            />
            <p v-if="erroTitulo" class="error-message">
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="7" cy="7" r="6" stroke="currentColor" stroke-width="1.5"/>
                <path d="M7 4v4M7 10v.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
              </svg>
              {{ erroTitulo }}
            </p>
          </div>

          <!-- Campo Produto -->
          <div class="form-group">
            <label class="form-label" for="produto">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="2" y="3" width="12" height="10" rx="1" stroke="currentColor" stroke-width="1.5"/>
                <path d="M6 7h4M6 10h2" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
              </svg>
              Produto *
            </label>
            <select
              id="produto"
              v-model="chamado.produtoId"
              class="form-input"
              :class="{ 'input-error': erroProduto }"
            >
              <option value="" disabled>Selecione um produto</option>
              <option v-for="produto in produtos" :key="produto.id" :value="produto.id">
                {{ produto.nome }}
              </option>
            </select>
            <p v-if="erroProduto" class="error-message">
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="7" cy="7" r="6" stroke="currentColor" stroke-width="1.5"/>
                <path d="M7 4v4M7 10v.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
              </svg>
              {{ erroProduto }}
            </p>
          </div>

          <!-- Campo Descrição -->
          <div class="form-group">
            <label class="form-label" for="descricao">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="2" y="2" width="12" height="12" rx="2" stroke="currentColor" stroke-width="1.5"/>
                <path d="M5 6h6M5 9h4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
              </svg>
              Descrição do Problema *
            </label>
            <textarea
              id="descricao"
              class="form-textarea"
              placeholder="Descreva detalhadamente o problema ou solicitação..."
              v-model="chamado.descricao"
              rows="5"
              :class="{ 'input-error': erroDescricao }"
            ></textarea>
            <p v-if="erroDescricao" class="error-message">
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="7" cy="7" r="6" stroke="currentColor" stroke-width="1.5"/>
                <path d="M7 4v4M7 10v.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
              </svg>
              {{ erroDescricao }}
            </p>
          </div>

          <!-- Área de Anexo -->
          <div class="attachment-section">
            <input 
              ref="fileInput" 
              type="file" 
              multiple 
              accept=".pdf,.png,.jpg,.jpeg"
              style="display: none" 
              @change="handleFileUpload"
            />
            <button type="button" class="btn-attachment" @click="$refs.fileInput.click()">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M17 9.5L10 16.5c-1.7 1.7-4.3 1.7-6 0s-1.7-4.3 0-6L11 3.5c1.1-1.1 2.9-1.1 4 0s1.1 2.9 0 4L8 14.5c-.6.6-1.4.6-2 0-.6-.6-.6-1.4 0-2L12 6.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <span>Anexar Arquivo</span>
            </button>
            <span class="attachment-hint">Formatos aceitos: PDF, PNG, JPG (máx. 5MB cada)</span>
            
            <!-- Lista de arquivos anexados -->
            <div v-if="arquivosAnexados.length > 0" class="files-list">
              <div v-for="(file, index) in arquivosAnexados" :key="index" class="file-item">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9 1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V5L9 1z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M9 1v4h4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <span class="file-name">{{ file.name }}</span>
                <span class="file-size">({{ formatFileSize(file.size) }})</span>
                <button type="button" class="btn-remove-file" @click="removerArquivo(index)">
                  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M11 3L3 11M3 3l8 8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
                  </svg>
                </button>
              </div>
            </div>
          </div>

          <!-- Botões de Ação -->
          <div class="modal-actions">
            <button type="button" class="btn-secondary" @click="closeModal">
              Cancelar
            </button>
            <button type="submit" class="btn-primary" :disabled="disableBtn">
              <svg v-if="!disableBtn" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M16 2L8 10M16 2l-6 14-2-6-6-2L16 2z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <span v-if="disableBtn">Enviando...</span>
              <span v-else>Enviar Chamado</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapGetters } from "vuex"; 
import api from '@/api/axios';

export default {
    name: 'ModalAbrirChamado',
    computed: {
        ...mapGetters({
            showModalCreate: "GET_ABRIR_MODAL_CHAMADO",
            user: 'auth/user',
        }),
    },
    data() {
    return {
        disableBtn: false,
        erroTitulo: '',
        erroDescricao: '',
        erroProduto: '',
        produtos: [],
        carregandoProdutos: false,
        chamado: {
            titulo: '',
            descricao: '',
            produtoId: ''
        },
        arquivosAnexados: [],
        representante: {
            Guid: '',
            ClienteId: '',
            Nome: '',
            Email: '',
            Cpf: '',
            Documento: '',
            UsPerson: false,
            PoliticamenteExposta: false,
            EmissorOrdem: false,
            Tipo: ''
            }
        }
    },
    mounted() {
        this.representante.ClienteId = this.user.ClienteId;
    },
    created() {
        this.carregarProdutos();
    },
    watch: {
        showModalCreate(){
            console.log('entrei');
        }
    },
    methods: {
        closeModal() {
            this.limparChamado();
            this.$store.commit("SET_ABRIR_MODAL_CHAMADO", false);
        },
        limparChamado() {
            this.chamado = {
                titulo: '',
                descricao: '',
                produtoId: ''
            };
            this.arquivosAnexados = [];
            this.erroTitulo = '';
            this.erroDescricao = '';
            this.erroProduto = '';
            if (this.$refs.fileInput) {
                this.$refs.fileInput.value = '';
            }
        },
        async carregarProdutos() {
            this.carregandoProdutos = true;
            
            try {
                const response = await api.get('/empresa/meus-produtos', {
                    withCredentials: true
                });
                
                this.produtos = response.data.map(p => ({
                    id: p.id || p.Id,
                    nome: p.nome || p.Nome
                }));
                
                this.carregandoProdutos = false;
            } catch (error) {
                this.carregandoProdutos = false;
                console.error('Erro ao carregar produtos:', error);
                
                // Se houver erro, mostra mensagem mas não bloqueia o formulário
                if (error.response?.status !== 401) {
                    this.$swal({
                        icon: 'warning',
                        title: 'Aviso',
                        text: 'Não foi possível carregar a lista de produtos.',
                    });
                }
            }
        },
        validarFormulario() {
            let valido = true;
            
            // Validar título
            if (!this.chamado.titulo || this.chamado.titulo.trim() === '') {
                this.erroTitulo = 'O título é obrigatório';
                valido = false;
            } else if (this.chamado.titulo.trim().length < 5) {
                this.erroTitulo = 'O título deve ter pelo menos 5 caracteres';
                valido = false;
            } else {
                this.erroTitulo = '';
            }
            
            // Validar produto
            if (!this.chamado.produtoId || this.chamado.produtoId === '') {
                this.erroProduto = 'Selecione um produto';
                valido = false;
            } else {
                this.erroProduto = '';
            }
            
            // Validar descrição
            if (!this.chamado.descricao || this.chamado.descricao.trim() === '') {
                this.erroDescricao = 'A descrição é obrigatória';
                valido = false;
            } else if (this.chamado.descricao.trim().length < 10) {
                this.erroDescricao = 'A descrição deve ter pelo menos 10 caracteres';
                valido = false;
            } else {
                this.erroDescricao = '';
            }
            
            return valido;
        },
        handleFileUpload(event) {
            const files = Array.from(event.target.files);
            const MAX_SIZE = 5 * 1024 * 1024; // 5MB
            
            files.forEach(file => {
                if (file.size > MAX_SIZE) {
                    this.$swal({
                        icon: 'warning',
                        title: 'Arquivo muito grande',
                        text: `O arquivo "${file.name}" excede o tamanho máximo de 5MB.`,
                    });
                    return;
                }
                
                // Verifica se já existe um arquivo com o mesmo nome
                if (!this.arquivosAnexados.find(f => f.name === file.name)) {
                    this.arquivosAnexados.push(file);
                }
            });
        },
        removerArquivo(index) {
            this.arquivosAnexados.splice(index, 1);
        },
        formatFileSize(bytes) {
            if (bytes === 0) return '0 Bytes';
            const k = 1024;
            const sizes = ['Bytes', 'KB', 'MB'];
            const i = Math.floor(Math.log(bytes) / Math.log(k));
            return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i];
        },
        limparObj(){
            this.representante = {
                Guid: '',
                ClienteId: this.user.ClienteId,
                Nome: '',
                Email: '',
                Documento: '',
                Cpf: '',
                EmissorOrdem: false,
                UsPerson: false,
                PoliticamenteExposta: false,
                Tipo: ''
            };
        },
        async salvarRepresentante(){
            // Validar formulário
            if (!this.validarFormulario()) {
                return;
            }
            
            this.disableBtn = true;
            
            try {
                // Cria FormData para enviar arquivo + dados
                const formData = new FormData();
                
                // Adiciona os campos de texto (PascalCase para compatibilidade com C#)
                formData.append('Titulo', this.chamado.titulo);
                formData.append('Descricao', this.chamado.descricao);
                formData.append('ProdutoId', this.chamado.produtoId);
                // Não enviamos Prioridade (como solicitado)
                
                // Adiciona os arquivos anexados
                this.arquivosAnexados.forEach((file) => {
                    formData.append('Anexos', file);
                });
                
                // Faz o POST para a API
                const response = await api.post('/chamado', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    },
                    withCredentials: true // Importante para enviar cookies de sessão
                });
                
                this.disableBtn = false;
                
                if (response.status === 201 || response.status === 200) {
                    this.$swal({
                        icon: 'success',
                        title: 'Chamado criado com sucesso!',
                        text: `Seu chamado "${this.chamado.titulo}" foi registrado. Entraremos em contato em breve.`,
                        timer: 3000,
                        showConfirmButton: true
                    });
                    this.closeModal();
                    
                    // Emitir evento para atualizar lista de chamados (se necessário)
                    this.$emit('chamado-criado', response.data);
                }
            } catch(error) {
                this.disableBtn = false;
                console.error('Erro ao criar chamado:', error);
                
                let errorMessage = 'Ocorreu um erro ao processar sua solicitação.';
                
                if (error.response) {
                    if (error.response.status === 401) {
                        errorMessage = 'Sessão expirada. Por favor, faça login novamente.';
                        // Redireciona para login após 2 segundos
                        setTimeout(() => {
                            this.$router.push('/login');
                        }, 2000);
                    } else if (error.response.data?.message || error.response.data?.Message) {
                        errorMessage = error.response.data.message || error.response.data.Message;
                    }
                }
                
                this.$swal({
                    icon: 'error',
                    title: 'Erro ao criar chamado',
                    text: errorMessage,
                });
            }
        }
    },
};
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');

/* Reset Global do Modal */
.modal-overlay *,
.modal-overlay *::before,
.modal-overlay *::after {
  box-sizing: border-box;
}

/* Transição do Modal */
.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.3s ease;
}

.modal-fade-enter-from,
.modal-fade-leave-to {
  opacity: 0;
}

.modal-fade-enter-active .modal-container,
.modal-fade-leave-active .modal-container {
  transition: transform 0.3s ease;
}

.modal-fade-enter-from .modal-container,
.modal-fade-leave-to .modal-container {
  transform: scale(0.95);
}

/* Overlay do Modal */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 0;
  overflow: hidden;
}

/* Container do Modal */
.modal-container {
  background: white;
  border-radius: 20px;
  width: calc(100% - 2rem);
  max-width: 560px;
  max-height: calc(100vh - 2rem);
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  position: relative;
  animation: slideUp 0.3s ease;
  word-wrap: break-word;
  overflow-wrap: break-word;
  display: flex;
  flex-direction: column;
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Botão Fechar */
.modal-close {
  position: absolute;
  top: 1.25rem;
  right: 1.25rem;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #f3f4f6;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  z-index: 10;

  &:hover {
    background: #e5e7eb;
    transform: rotate(90deg);
  }

  svg {
    color: #6b7280;
  }
}

/* Header do Modal */
.modal-header {
  text-align: center;
  padding: 2.5rem 2rem 1.5rem;
  border-bottom: 2px solid #f3f4f6;
  max-width: 100%;
  overflow: hidden;
  flex-shrink: 0;
}

.modal-icon {
  margin-bottom: 1.25rem;
  display: inline-block;
  animation: scaleIn 0.5s ease;
}

@keyframes scaleIn {
  from {
    transform: scale(0);
  }
  to {
    transform: scale(1);
  }
}

.modal-title {
  font-size: 1.75rem;
  font-weight: 700;
  color: #00235C;
  margin-bottom: 0.5rem;
  letter-spacing: -0.5px;
}

.modal-subtitle {
  font-size: 0.9375rem;
  color: #6b7280;
  line-height: 1.5;
  max-width: 400px;
  margin: 0 auto;
  word-wrap: break-word;
  overflow-wrap: break-word;
}

/* Formulário */
.modal-form {
  padding: 2rem;
  overflow-x: hidden;
  overflow-y: auto;
  flex: 1;
  min-height: 0;

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: #f3f4f6;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: #d1d5db;
    border-radius: 4px;

    &:hover {
      background: #9ca3af;
    }
  }
}

.form-group {
  margin-bottom: 1.5rem;
  width: 100%;
}

.form-label {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.875rem;
  font-weight: 600;
  color: #374151;
  margin-bottom: 0.5rem;

  svg {
    color: #00235C;
  }
}

.form-input,
.form-textarea {
  width: 100%;
  padding: 0.875rem 1rem;
  border: 2px solid #e5e7eb;
  border-radius: 12px;
  font-family: 'Inter', sans-serif;
  font-size: 0.9375rem;
  color: #1f2937;
  transition: all 0.3s ease;
  box-sizing: border-box;

  &:focus {
    outline: none;
    border-color: #00235C;
    box-shadow: 0 0 0 3px rgba(0, 35, 92, 0.1);
  }

  &::placeholder {
    color: #9ca3af;
  }

  &.input-error {
    border-color: #ef4444;
    background: #fef2f2;
  }
}

/* Estilos específicos para select */
select.form-input {
  cursor: pointer;
  background-color: white;
  background-image: url("data:image/svg+xml,%3Csvg width='12' height='8' viewBox='0 0 12 8' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1l5 5 5-5' stroke='%236b7280' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 1rem center;
  background-size: 12px;
  padding-right: 2.5rem;
  appearance: none;

  option {
    color: #1f2937;
    padding: 0.5rem;
  }

  option:disabled {
    color: #9ca3af;
  }
}

.form-textarea {
  resize: vertical;
  min-height: 120px;
  line-height: 1.6;
}

.error-message {
  display: flex;
  align-items: center;
  gap: 0.375rem;
  font-size: 0.8125rem;
  color: #ef4444;
  margin-top: 0.5rem;
  animation: shake 0.3s ease;

  svg {
    flex-shrink: 0;
  }
}

@keyframes shake {
  0%, 100% { transform: translateX(0); }
  25% { transform: translateX(-5px); }
  75% { transform: translateX(5px); }
}

/* Seção de Anexo */
.attachment-section {
  margin-bottom: 1.5rem;
  padding: 1.25rem;
  background: #f9fafb;
  border-radius: 12px;
  border: 2px dashed #e5e7eb;
  text-align: center;
  max-width: 100%;
  overflow: hidden;
}

.btn-attachment {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1.5rem;
  background: white;
  color: #6b7280;
  border: 2px solid #e5e7eb;
  border-radius: 10px;
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-bottom: 0.75rem;
  max-width: 100%;

  &:hover {
    background: #f9fafb;
    border-color: #00235C;
    color: #00235C;
  }

  svg {
    width: 20px;
    height: 20px;
  }
}

.attachment-hint {
  display: block;
  font-size: 0.75rem;
  color: #9ca3af;
}

/* Lista de Arquivos Anexados */
.files-list {
  margin-top: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.file-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.625rem 0.875rem;
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  font-size: 0.8125rem;
  transition: all 0.2s ease;

  &:hover {
    border-color: #d1d5db;
    background: #f9fafb;
  }

  svg {
    color: #6b7280;
    flex-shrink: 0;
  }
}

.file-name {
  flex: 1;
  color: #374151;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
}

.file-size {
  color: #9ca3af;
  font-size: 0.75rem;
  flex-shrink: 0;
}

.btn-remove-file {
  background: transparent;
  border: none;
  padding: 0.25rem;
  cursor: pointer;
  color: #ef4444;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: all 0.2s ease;
  flex-shrink: 0;

  &:hover {
    background: #fef2f2;
  }

  svg {
    color: #ef4444;
  }
}

/* Botões de Ação */
.modal-actions {
  display: flex;
  gap: 1rem;
  justify-content: flex-end;
  padding-top: 1rem;
  border-top: 2px solid #f3f4f6;
  max-width: 100%;
  overflow: hidden;
  flex-wrap: wrap;
}

.btn-secondary,
.btn-primary {
  padding: 0.75rem 1.5rem;
  border-radius: 10px;
  font-size: 0.9375rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  border: none;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  justify-content: center;
  min-width: 0;
  max-width: 100%;
}

.btn-secondary {
  background: white;
  color: #6b7280;
  border: 2px solid #e5e7eb;

  &:hover {
    background: #f9fafb;
    border-color: #d1d5db;
  }
}

.btn-primary {
  background: linear-gradient(135deg, #00235C 0%, #001a45 100%);
  color: white;

  &:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 8px 16px rgba(0, 35, 92, 0.3);
  }

  &:active:not(:disabled) {
    transform: translateY(0);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  svg {
    width: 18px;
    height: 18px;
  }
}

/* Responsividade */
@media (max-width: 640px) {
  .modal-container {
    border-radius: 16px;
    width: calc(100% - 1rem);
    max-height: calc(100vh - 1rem);
  }

  .modal-header {
    padding: 2rem 1.5rem 1.25rem;
  }

  .modal-title {
    font-size: 1.5rem;
  }

  .modal-subtitle {
    font-size: 0.875rem;
  }

  .modal-form {
    padding: 1.5rem;
  }

  .modal-actions {
    flex-direction: column;
    gap: 0.75rem;
  }

  .btn-secondary,
  .btn-primary {
    width: 100%;
  }

  .modal-close {
    width: 36px;
    height: 36px;
    top: 1rem;
    right: 1rem;
  }
}
</style>
